<template>
    <el-form
        :id="formID"
        :key="formID"
        :ref="formID"
        :model="model"
        :rules="rules"
        :label-width="innerLabelWidth"
        :label-position="labelPosition"
        :show-message="showMessage"
        v-bind="$attrs"
        :class="['form-custom', `form-custom-${mode}`]"
        v-on="$listeners"
        size="mini"
        @submit.native.prevent
    >
        <!-- 常规查询 -->
        <BaseList
            v-model="model"
            :config="normalConfig"
            :resets.sync="resets"
            :disableds="disableds"
            :loading="queryLoading"
            :popper-class="computedPopperClass"
            @after-leave="val => $emit('after-leave', val)"
            @advance="val => $emit('advance', val)"
            @query-click="handleExpectQuery"
            @add-click="$emit('add-click')"
            @other-click="$emit('other-click')"
            @enter-click="handleExpectQuery"
        />

        <!-- 高级查询 -->
        <BaseList
            v-if="innerAdvanceTags.size"
            v-show="model[advanceBtn.prop || advanceBtn.mold]"
            v-model="model"
            :config="advanceConfig"
            :resets.sync="resets"
            :disableds="disableds"
            :loading="queryLoading"
            :popper-class="computedPopperClass"
            class="form-advance-items-wrapper"
            @after-leave="val => $emit('after-leave', val)"
            @advance="val => $emit('advance', val)"
            @query-click="handleExpectQuery"
            @add-click="$emit('add-click')"
            @other-click="$emit('other-click')"
            @enter-click="handleExpectQuery"
        />

        <div
            v-if="isVertical"
            :class="[
                `form-item`,
                `form-item-button-groups`
            ]"
        >
            <el-button
                v-bind="queryBtn"
                :loading="queryLoading"
                :disabled="disableds.querybutton"
                class="query-button"
                @click="handleExpectQuery"
            >
                {{ queryBtn.name || '查询' }}
            </el-button>

            <AdvanceDefaultQuerySwtich
                v-if="advanceBtn && (advanceBtn.prop || advanceBtn.mold)"
                v-model="model[advanceBtn.prop || advanceBtn.mold]"
                v-bind="advanceBtn"
                :reset.sync="resets[advanceBtn.prop || advanceBtn.mold]"
                :disabled="disableds[advanceBtn.prop || advanceBtn.mold]"
                @advance="$emit('advance', model[advanceBtn.prop || advanceBtn.mold])"
            />
        </div>
    </el-form>
</template>

<style lang="scss">
@import "./index.scss";
</style>

<script>
// 注： 支持的类型 请查看configs.js

import AdvanceDefaultQuerySwtich from "./AdvanceDefaultQuerySwtich";
import BaseList from "./List";

import { SUPPORT_TYPE, getDefaultValue } from "./configs";

const deepEquals = (a, b) => {
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) {
      return false;
    }

    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }

    return true;
  }

  return a === b;
};
export default {
  name: "FormCustom",

  components: {
    BaseList,
    AdvanceDefaultQuerySwtich
  },

  inheritAttrs: false,

  props: {
    config: {
      type: Array,
      default: () => []
    },

    popperClass: {
      type: String,
      default: ""
    },

    reset: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    // 组件加载完成时， 执行一次默认查询
    mountAndQuery: {
      type: Boolean,
      default: false
    },

    // 用于表单异步时 手动触发查询
    asyncQuery: {
      default: false,
      type: Boolean
    },

    // 样式 ： 水平 | 垂直
    mode: {
      default: "horizontal",
      validator: function (val) {
        return ["horizontal", "vertical"].includes(val);
      }
    },

    // 高级查询 包含的prop
    advanceTags: {
      default: () => [],
      type: Array
    },

    // 是否是纯净模式 (删除 renderable === false 的item.prop对应model的值)
    pureable: {
      default: false,
      type: Boolean
    },

    value: {
      default: () => ({}),
      type: Object
    },

    showMessage:{
      type:Boolean,
      default:false
    },

    labelPosition:{
      type:String,
      default:"top"
    },

    labelWidth: {
      default: "80px",
      type: [ String, Number]
    },

    rules: {
      type: Object,
      default: null
    },

    /**按钮是否处于loading状态 */
    buttonLoading:{
      type:Boolean,
      default:false
    }
  },

  data() {
    return {
      resets: {},

      disableds: {
        querybutton: false
      },

      formID: `formID-${Math.random()
        .toString(36)
        .slice(2)}`,

      linkItems: [],
      unwatchers: [],

      advanceBtn: {},
      queryBtn: {},

      advanceConfig: [],
      normalConfig: [],

      innerAdvanceTags: new Set([]),

      unrenderable: new Set([]),
      uploadKeys: new Set([]),

      isRendering: false,
      queryLoading: false,
      innerMountAndQuery: false,
      isInit: true
    };
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    },

    isVertical() {
      return this.mode === "vertical";
    },

    computedPopperClass() {
      return (this.isVertical ? ["form-custom-popper", this.popperClass] : []).join(" ");
    },

    innerLabelWidth() {
      return (this.labelWidth + "").replace(/px/, "") + "px";
    }

  },

  watch: {
    config: {
      deep: true,
      immediate: true,
      handler: function (newVal, oldVal) {
        if (!this.isRendering && newVal !== oldVal && newVal.length) {
          this.init();
        }
      }
    },

    value: {
      deep: true,
      immediate: true,
      handler: function (newVal) {
        if (!this.isEmptyObject(newVal) && !this.isRendering && this.innerMountAndQuery) {
          this.innerMountAndQuery = false;
          this.handleExpectQuery();
        }
      }
    },

    reset(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.init();

        // temporary hack
        this.setResets(true);

        this.$emit("update:reset", false);
      }
    },

    disabled(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setDisableds(newVal);

        this.$emit("disabled");
      }
    },

    asyncQuery(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.$nextTick(() => {
          this.handleExpectQuery();
          this.$emit("update:asyncQuery", false);
        });
      }
    },

    advanceTags(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.innerAdvanceTags.clear();

        val.forEach(tag => {
          this.innerAdvanceTags.add(tag);
        });

        if (!this.isRendering) {
          this.init();
        }
      }
    },

    buttonLoading(val) {
      this.queryLoading = val;
    }
  },

  created() {
    //    this.innerMountAndQuery = this.mountAndQuery;
  },

  methods: {
    init() {
      if (!this.isRendering) {
        this.isRendering = true;

        this.clearValidate();

        this.unrenderable.clear();
        this.uploadKeys.clear();

        this.disableds = {
          querybutton: this.disabled
        };

        const {
          advance = {},
          querybutton = {},
          advanceItems = [],
          normalItems = []
        } = this.separateAdvanceAndNormal(this.config);

        this.normalConfig = normalItems;

        this.generateFormModel(normalItems);

        this.advanceBtn = advance;
        this.generateFormModel(advance);

        this.queryBtn = querybutton;

        this.advanceConfig = advanceItems;
        if (advanceItems.length) {
          this.generateFormModel(advanceItems);
        }

        this.generateLink();

        //        this.innerMountAndQuery = this.mountAndQuery;

        this.isInit = false;

        this.isRendering = false;
      }
    },

    generateFormModel(config) {
      if (Array.isArray(config)) {
        config.forEach(item => {
          if (Array.isArray(item)) {
            this.generateFormModel(item);
          } else {
            if (!item.mold) {
              throw Error(
                `Each config's child must has a 'mold' prop, it could be ${SUPPORT_TYPE.concat(
                  "querybutton"
                ).join("|")}`
              );

              return;
            }

            item.mold = item.mold.toLowerCase();

            this.setModel(item);

            if (item.link) {
              this.linkItems.push(item);
            }
          }
        });
      } else {
        if (!Object.keys(config).length) {
          return;
        }

        if (!config.mold) {
          throw Error(
            `Each config's child must has a 'mold' prop, it could be ${SUPPORT_TYPE.concat(
              "querybutton"
            ).join("|")}`
          );
          return;
        }

        config.mold = config.mold.toLowerCase();

        this.setModel(config);
      }
    },

    generateLink() {
      while (this.unwatchers.length) {
        this.unwatchers.pop()();
      }

      this.linkItems.map(item => {
        this.setWatchers(item);
      });

      this.linkItems = [];
    },

    setModel(item, setValue) {
      let { prop, mold } = item;

      if (this.pureable) { // 纯净模式
        if (item.renderable === false) {
          this.unrenderable.add(prop);

          this.$delete(this.model, prop);
          return;
        } else if (this.unrenderable.has(prop)) {
          this.unrenderable.delete(prop);
        }
      }

      prop = prop ? prop : mold;

      const matchedResult = getDefaultValue(item);

      if (matchedResult !== null) {
        if (!(this.isInit && this.model[prop] !== undefined)) {
          this.$set(this.model, prop, matchedResult.value);
          //          this.$set(this.model, prop, (setValue ? this.model[prop] : matchedResult.value) || matchedResult.value);
        }

        this.$set(this.resets, prop, false);
        this.$set(this.disableds, prop, this.disabled || item.disabled);
      }
    },

    setWatchers(item) {
      const { link, prop: itemProp } = item;
      let isOneToLinkAll = false,
        links, isComplex;

      if (Array.isArray(link)) {
        links = link;
        isOneToLinkAll = links.every(item => item.mold);
        isComplex = !!(links.find(item => item.mold) && links.find(item => !item.mold));
      } else {
        links = [link];
      }

      links.forEach(link =>
        this.setSingleLinkWatch(link, itemProp, isOneToLinkAll, isComplex, link.mold)
      );
    },

    setSingleLinkWatch(link, itemProp, isOneToLinkAll, isComplex, isModelEverGenerated) {
      const { prop, handler, mold } = link;

      if (!this.isFunc(handler)) {
        return;
      }

      let targetProp, watchedProp;

      if (isOneToLinkAll) {
        this.generateFormModel(link);
        targetProp = itemProp;
        watchedProp = prop;
      } else if (isComplex) {
        if (isModelEverGenerated) {
          this.generateFormModel(link);
        }
        targetProp = itemProp;
        watchedProp = prop;
      } else {
        if (mold) {
          this.generateFormModel(link);
          targetProp = prop;
          watchedProp = itemProp;
        } else {
          targetProp = itemProp;
          watchedProp = prop;
        }
      }

      const unwatcher = this.$watch(`model.${targetProp}`, {
        immediate: true,
        deep: true,
        handler: async function (newVal, oldVal) {
          if (watchedProp) {
            if (!deepEquals(newVal, oldVal)) {
              const defaultAndOptions = await handler(newVal);

              const newItem = {
                prop: watchedProp,
                ...defaultAndOptions
              };

              this.replaceOptions(newItem);
            }
          }
        }
      });

      this.unwatchers.push(unwatcher);
    },

    replaceOptions({ prop, ...pramas }, config) {
      let finded = false;

      const replaceOptionsHelper = ({ prop, pramas }, config) => {
        const isAdvance =
          this.innerAdvanceTags.size && this.innerAdvanceTags.has(prop);

        if (finded) {
          return;
        }

        const tConfig = config
          ? config
          : isAdvance
            ? this.advanceConfig
            : this.normalConfig;

        tConfig.forEach((item, idx) => {
          if (Array.isArray(item)) {
            replaceOptionsHelper(
              {
                prop,
                pramas
              },
              item
            );
          } else if (Array.isArray(item.link)) {
            replaceOptionsHelper(
              {
                prop,
                pramas
              },
              item.link
            );
          } else {
            if (item.prop === prop) {
              finded = true;
              const newItem = { ...item, ...pramas };

              tConfig.splice(idx, 1, newItem);

              if (newItem.mold) {
                this.setModel(newItem, true);
              }
            }
          }
        });
      };

      replaceOptionsHelper({ prop, pramas }, config);
    },

    setResets(val = false, prop = null) {
      if (prop) {
        this.resets[prop] = val;
      } else {
        Object.keys(this.resets).forEach(key => {
          this.resets[key] = val;
        });
      }
    },

    setDisableds(val = false, prop = null) {
      if (prop) {
        this.disableds[prop] = val;
      } else {
        Object.keys(this.disableds).forEach(key => {
          this.disableds[key] = val;
        });
      }
    },

    separateAdvanceAndNormal(config = this.config) {
      const advance = this.innerAdvanceTags;
      const isVertical = this.isVertical;

      const reducer = config => config.reduce(
        (prev, item) => {
          if (Array.isArray(item)) {
            const { advanceItems, normalItems, ...rest } = reducer(item);

            advanceItems.length && prev.advanceItems.push(advanceItems);
            normalItems.length && prev.normalItems.push(normalItems);

            return {
              ...prev,
              ...rest
            };
          } else {
            let { mold, prop } = item;
            //            if (mold === "upload") {
            //              this.uploadKeys.add(prop);
            //            }

            if (isVertical) {
              if (mold === "advance") {
                prop = prop ? prop : mold;
                prev[prop] = { ...item, prop };
              } else if (mold === "querybutton") {
                prev[mold] = item;
              } else if (advance.has(prop)) {
                prev.advanceItems.push(item);
              } else if (item.advance) {
                this.innerAdvanceTags.add(item.prop);

                prev.advanceItems.push(item);
              } else {
                prev.normalItems.push(item);
              }
            } else {
              if (advance.has(prop)) {
                prev.advanceItems.push(item);
              } else if (item.advance) {
                this.innerAdvanceTags.add(item.prop);

                prev.advanceItems.push(item);
              } else {
                if (mold === "advance") {
                  prop = prop ? prop : mold;
                  prev[prop] = { ...item, prop };
                }

                prev.normalItems.push(item);
              }
            }
          }

          return prev;
        },
        {
          advanceItems: [],
          normalItems: []
        }
      );

      return reducer(config);
    },

    isFunc(callBack) {
      return callBack && typeof callBack === "function";
    },

    isEmptyObject(obj) {
      const isObj = Object.prototype.toString.call(obj).toLowerCase() !== "[object object]";
      return !Object.keys(isObj ? {} : obj).length;
    },

    async handleExpectQuery(config,loadTpye = "default") {
      this.queryLoading = true;

      try {
        if (this.$listeners.query) {

          await this.validate();

          let model;

          if (this.uploadKeys.size) {
            model = this.convertModelToFormData(this.model);
            config = {
              headers: {
                "Content-Type": "multipart/form-data"
              },
              ...config
            };
          } else {
            model = JSON.parse(JSON.stringify(this.model));
          }

          await this.$listeners.query(model,config,loadTpye);
        } else {
          throw new Error(
            "must specify @query event when there is a query button"
          );
        }
      } catch (err) {
        console.error("form custom error -> handleExpectQuery:", err);
      } finally {
        this.queryLoading = false;
      }
    },

    convertModelToFormData(model) {
      const fd = new FormData();
      Object.entries(model).forEach(([key, value]) => {
        fd.append(key, value instanceof window.FormData ? value.get(key) : value);
      });
      return fd;
    },

    clearValidate() {
      if (this.rules && this.$refs[this.formID]) {
        this.$refs[this.formID].clearValidate();
      }
    },

    validate() {
      if (this.rules && this.$refs[this.formID]) {
        return this.$refs[this.formID].validate();
      }

      return Promise.resolve();
    }
  }
};
</script>
